export const globalServicesFormTemplate = {
  active: true,
  audit: {
    createdAt: '',
    createdBy: '',
    modifedAt: '',
    modifiedBy: ''
  },
  name: '',
  description: '',
  category: '',
  defaultRate: '',
  defaultDurationMin: ''
}
